import React, { useState, useRef } from "react";
import TableRows from "./TableRow";
function AddDeleteTableRows({
  itemType,
  ply,
  printdesc,
  calculationtype,
  unitsize,
  challannol,
  data,
  add,
  edit,
  deleter,
  plyquantity,
  Unit,
  sqmt,
  UnitSize,
 
  CustomerId,
  ChallanNoL,
  Code,
 
  CodeArray,
  GlobalOptions,
}) {




  return (
    <div className="table-responsive">
      <table className="" style={{ padding: "0", marginBottom: "10px" }}>
        <thead>
          <tr>
            <th>Sr.</th>
            <th>Is Dir.</th>
            
             {GlobalOptions?.IsMultiUnit == true ? <th>Unit Size</th> : null}
            {GlobalOptions?.IsStyleDropdown == true ? <th>Select Style</th> : null}
            <th>Style</th>
            <th>Item Type</th>
            {CustomerId == 2 ||
            CustomerId == 4 ||
            CustomerId == 5 ||
            CustomerId == 6 ||
            CustomerId == 11 ||
            CustomerId == 12 ? (
              <th>DescriptionL</th>
            ) : CustomerId == 9 || CustomerId == 10 ? (
              <th>OC No./ Desc.</th>
            ) : null}
            <th>Ply</th>
            <th>Length</th>
            <th></th>
            <th>Width</th>
            <th></th>
            <th>Height</th>
            <th></th>
             {GlobalOptions?.IsChallanNo == true ? <th>Challan No.</th> : null}
            {/* {CustomerId == 0 ? <th>Sq mt</th> : null} */}
            <th>Calculation Type</th>
            <th>Sq mt</th>
            {/* {CustomerId == 0 ? <th>Sq mt</th> : null} */}
            <th>Qty</th>
            {CustomerId == 2 ? <th>Unit</th> : null}
            <th>Rate</th>
            <th>Print Desc</th>
            <th>Prn. Rate</th>
            <th>Amount</th>
            <th>Del</th>
            <th>Add</th>
            {/* <th><button type="button" className="btn btn-outline-success" onClick={addTableRows} >+</button></th> */}
          </tr>
        </thead>
        <tbody>
          <TableRows
            rowsData={data}
            deleteTableRows={deleter}
            handleChange={edit}
            addTableRows={add}
            itemType={itemType}
            unitsize={unitsize}
            sqmt={sqmt}
            challannol={challannol}
            printdesc={printdesc}
            ply={ply}
            calculationtype={calculationtype}
            plyquantity={plyquantity}
            Unit={Unit}
            CustomerId={CustomerId}
            Code={Code}
            GlobalOptions={GlobalOptions}
            CodeArray={CodeArray}
          />
        </tbody>
      </table>
    </div>
  );
}
export default AddDeleteTableRows;
